<!-- SETTE redesign (CLIPPING-598): Panel look (bg-surface, border-line, rounded-2xl, no shadow)
     and Правило В - the value is always text-ink; color lives only on the delta. trendUp's
     emerald/rose -> positive/negative tokens; the trending_up/down icon is what carries the
     sign (Принцип 2 - color is never alone), same reasoning the source design kept its own
     lucide trend arrows instead of switching to +/- glyphs.

     KPI cards redesign (2026-11-01): the main number is the dominant element (text-2xl/font-bold,
     up from text-xl/font-medium) with the % change right next to it on the SAME line, colored -
     not stacked below as its own row. The comparison detail ("(49 → 34) vs 01.07.2026 –
     30.09.2026") is no longer printed as visible text; it only shows in a tooltip on the delta
     pill (matTooltip - hover on desktop, tap on touch, same as InfoIconComponent/
     LowDataBadgeComponent's existing "wide-tooltip" pattern) via shortDeltaLabel/deltaTooltip. -->
@if (icon) {
<div class="bg-surface p-3 rounded-2xl border border-line flex flex-col justify-between h-full">
	<div class="flex items-center justify-between">
		<span class="caption text-ink-subtle flex items-center gap-1">{{ label }}@if (infoKey) {<app-info-icon [key]="infoKey" [extraKey]="infoExtraKey"></app-info-icon>}</span>
		<mat-icon class="!w-3.5 !h-3.5 !text-sm" [class]="iconColorClass">{{ icon }}</mat-icon>
	</div>
	<div class="flex items-end justify-between mt-1">
		<div class="flex items-baseline gap-1.5">
			<span class="text-2xl font-bold text-ink tabular-nums" [class.opacity-60]="isLowSample">{{ value }}</span>
			@if (trendUp === undefined) {
			@if (shortDeltaLabel) {
			<span class="text-[11px] text-ink-subtle font-medium" [class.cursor-help]="deltaTooltip" matTooltipClass="wide-tooltip" matTooltipPosition="above" [matTooltip]="deltaTooltip">{{ shortDeltaLabel }}</span>
			}
			} @else if (shortDeltaLabel) {
			<span
				class="flex items-center gap-0.5 text-[11px] font-medium"
				[class]="trendColorClass ?? (trendUp ? 'text-positive' : 'text-negative')"
				[class.cursor-help]="deltaTooltip"
				matTooltipClass="wide-tooltip"
				matTooltipPosition="above"
				[matTooltip]="deltaTooltip">
				<mat-icon class="!w-3 !h-3 !text-xs">{{ (trendIconUp === undefined ? trendUp : trendIconUp) ? 'trending_up' : 'trending_down' }}</mat-icon>
				{{ shortDeltaLabel }}
			</span>
			}
		</div>
		@if (sparklineValues) {
		<div class="w-14 h-7 pb-1">
			<app-sparkline-chart [values]="sparklineValues" [color]="sparklineColor" height="28px"></app-sparkline-chart>
		</div>
		}
	</div>
	@if (footnote) {
	<div class="caption text-ink-subtle mt-1 border-t border-line pt-1 truncate font-normal">{{ footnote }}</div>
	}
	@if (sampleSize !== undefined) {
	<app-sample-size-note class="block mt-1" [count]="sampleSize"></app-sample-size-note>
	}
</div>
} @else if (sparklineValues) {
<div class="bg-surface p-3.5 rounded-2xl border border-line flex flex-col justify-between h-full">
	<div class="flex items-center justify-between">
		<span class="caption text-ink-subtle flex items-center gap-1">{{ label }}@if (infoKey) {<app-info-icon [key]="infoKey" [extraKey]="infoExtraKey"></app-info-icon>}</span>
		<span class="caption text-ink-subtle font-normal">{{ topRightNote }}</span>
	</div>
	<div class="flex items-baseline justify-between mt-1">
		<div class="flex items-baseline gap-1.5">
			@if (valueSuffix) {
			<span class="text-2xl font-bold text-ink tabular-nums flex items-baseline gap-1" [class.opacity-60]="isLowSample">
				{{ value }}
				<span class="caption text-ink-subtle">{{ valueSuffix }}</span>
			</span>
			} @else {
			<span class="text-2xl font-bold text-ink tabular-nums" [class.opacity-60]="isLowSample">{{ value }}</span>
			}
			@if (trendUp === undefined) {
			@if (shortDeltaLabel) {
			<span class="text-[11px] font-medium text-ink-subtle" [class.cursor-help]="deltaTooltip" matTooltipClass="wide-tooltip" matTooltipPosition="above" [matTooltip]="deltaTooltip">{{ shortDeltaLabel }}</span>
			}
			} @else if (shortDeltaLabel) {
			<span
				class="flex items-center gap-0.5 text-[11px] font-medium"
				[class]="trendUp ? 'text-positive' : 'text-negative'"
				[class.cursor-help]="deltaTooltip"
				matTooltipClass="wide-tooltip"
				matTooltipPosition="above"
				[matTooltip]="deltaTooltip">
				<mat-icon class="!w-3.5 !h-3.5 !text-sm">{{ trendUp ? 'trending_up' : 'trending_down' }}</mat-icon>
				{{ shortDeltaLabel }}
			</span>
			}
		</div>
		<div class="w-20 h-8">
			<app-sparkline-chart
				[values]="sparklineValues"
				[color]="sparklineColor"
				[zeroLine]="sparklineZeroLine"
				height="32px"></app-sparkline-chart>
		</div>
	</div>
	@if (sampleSize !== undefined) {
	<app-sample-size-note class="block mt-1" [count]="sampleSize"></app-sample-size-note>
	}
</div>
} @else {
<div class="bg-surface p-3.5 rounded-2xl border border-line h-full">
	<div class="caption text-ink-subtle font-normal flex items-center gap-1">{{ label }}@if (infoKey) {<app-info-icon [key]="infoKey" [extraKey]="infoExtraKey"></app-info-icon>}</div>
	<div class="flex items-baseline gap-2 mt-1">
		<span class="text-2xl font-bold tabular-nums" [class]="valueToneClass" [class.opacity-60]="isLowSample">{{ value }}</span>
		@if (trendUp === undefined) {
		@if (shortDeltaLabel) {
		<span class="body-sm text-ink-subtle" [class.cursor-help]="deltaTooltip" matTooltipClass="wide-tooltip" matTooltipPosition="above" [matTooltip]="deltaTooltip">{{ shortDeltaLabel }}</span>
		}
		} @else if (shortDeltaLabel) {
		<span
			class="body-sm font-medium flex items-center"
			[class]="trendColorClass ?? (trendUp ? 'text-positive' : 'text-negative')"
			[class.cursor-help]="deltaTooltip"
			matTooltipClass="wide-tooltip"
			matTooltipPosition="above"
			[matTooltip]="deltaTooltip">
			<mat-icon class="!w-3.5 !h-3.5 !text-sm mr-0.5">{{ trendUp ? 'trending_up' : 'trending_down' }}</mat-icon>
			{{ shortDeltaLabel }}
		</span>
		}
	</div>
	@if (sampleSize !== undefined) {
	<app-sample-size-note class="block mt-1" [count]="sampleSize"></app-sample-size-note>
	}
</div>
}
